<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b874g6/tc-custom/9781466803732.jpg?1720831243072" alt="This image is the cover for the book Smile of the Lamb"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smile of the Lamb
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In a chorus of voices David Grossman's <i>The Smile of the Lamb</i> tells the story of Uri, an idealistic young Israeli soldier serving in an army unit in the small Palestinian village of Andal, in the occupied territories, and his relationship with Khilmi, a nearly blind old Palestinian storyteller. </b><br/><br/>Gradually as the violent reality of the occupation that infects both the occupier and the occupied alike merges with the old man's stories, Uri, captivated by Khilmi's wisdom, tries to solve the riddles and deceits that make up his life.<br/><br/>Originally published in Hebrew in 1983, <i>The Smile of the Lamb</i> is a novel of disillusionment and a piercing examination of injustice and dishonesty.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Grossman, Betsy Rosenberg
      </h2>
      
      <p class="authorDescription body article"><B>David Grossman</B> has received several international awards for his writing, including the Premio Grinzane and the Premio Mondelo for <I>The Zigzag Kid</I>. He is the author of several novels, including <I>A Horse Walks into a Bar, The Book of Intimate Grammar,</I> as well as children's books, and a play. He lives in Jerusalem with his wife and children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a377cc2